import PubSub from "underpub-js";

var BlogNavigation = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BlogNavigation',
	};

	$.extend(true, this.options, options);

};

BlogNavigation.prototype.init = function() {

	var self = this;

};

export default BlogNavigation;
